<template>
  <div id="app">
    <router-view :key="$route.path"></router-view>
    <div class="main-container">
      <div>
        <TopPanel />
      </div>
      <div class="card-container">
        <div class="front-container">
          <div class="front-text">
            <h1>Master most in-demand skills</h1>
            <h2>Find affordable courses on cutting-edge tech</h2>
            <button class="action-button" @click="getStarted">
              Get Started
            </button>
          </div>
          <div class="image-container">
            <img
              class="front-image"
              v-lazy="'https://ztchecvzbsazdgbkuzzp.supabase.co/storage/v1/object/public/media-storage-bucket//logo_v5.png'"
              alt="front image"
              width="300"
              height="1350"
            >
          </div>
        </div>
        <div class="card-grid" :class="{ 'loading': !cstore.secData.length }">
          <Card
            v-for="card in cstore.secData"
            :key="card.id"
            :imageSrc="card.image_url"
            :id="card.id"
            :title="card.title"
            :contenttype="card.type"
            :details="card.short_desc"
            :price="card.price"
            :list_price="card.list_price"
          />
        </div>
        <Footer/>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue';
import TopPanel from './TopPanel.vue';
import Footer from './Footer.vue';
import { default as cstore } from '@/stores/dataStore.js';
import { default as ustore } from '@/stores/authStore.js';

export default {
  components: {
    Card,
    TopPanel,
    Footer,
  },
  data() {
    return {
      showForm: false,
      cstore: cstore,
      ustore: ustore,
      isLoading: true,
    };
  },
  async created() {
    await cstore.fetchSecData();
    this.isLoading = false;
  },
  methods: {
    toggleForm() {
      this.showForm = !this.showForm;
    },
    getStarted() {
      if (ustore.uData.role != 'authenticated') {
        this.$router.push(`/signup/`);
      }
    },
  }
};
</script>

<style>
:root {
  --sec-col: #111827;
  --prime-col: #0d121b;
  --top-panel-height: 60px;
  --btn-prime-col: #751aff;
  --btn-sec-col: #b3ffff;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  margin: 0;
  padding: 0;
}

.main-container {
  display: flex;
  flex-direction: column;
  background: var(--prime-col);
  width: 100%;
  /* padding-top: var(--top-panel-height); */
}

.front-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 4vw;
  max-width: 1200px;
  margin: 0 auto;
  /* gap: 2rem; */
  min-height: 400px;
}

.front-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: whitesmoke;
  flex: 1;
  min-width: 300px;
}

.front-text h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 1rem;
  line-height: 1.2;
}

.front-text h2 {
  font-size: 1.5rem;
  font-weight: 400;
  margin: 0 0 1.5rem;
  line-height: 1.4;
  opacity: 0.9;
}

.front-image {
  max-width: 100%;
  width: 400px;
  height: auto;
  border-radius: 5px;
  aspect-ratio: 777 / 964;
  display: block;
}

.image-container {
  flex: 1;
  min-width: 300px;
  display: flex;
  justify-content: center;
  min-height: 88.89px;
}

.card-container {
  flex-grow: 1;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  margin: 0 auto;
  padding-left: 7vw;
  padding-right: 7vw;
  min-height: 400px;
}

.card-grid.loading {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}

.card-grid.loading::before {
  content: '';
  grid-column: 1 / -1;
  height: 200px;
  background: var(--prime-col);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
}

.top-section {
  display: flex;
  width: 100%;
  z-index: 50;
  position: fixed;
  top: 0;
  height: var(--top-panel-height);
}

.action-button {
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: 2px solid var(--btn-sec-col);
  border-radius: 6px;
  background: var(--btn-prime-col);
  color: var(--btn-sec-col);
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
}

.action-button:hover {
  background: #001133;
}

@media (max-width: 768px) {
  .front-container {
    flex-direction: column-reverse;
    padding: 20px;
    text-align: center;
    min-height: 500px;
  }

  .front-text {
    align-items: center;
    min-width: 100%;
    margin-right: 0rem;
  }

  .front-text h1 {
    font-size: 2rem;
  }

  .front-text h2 {
    font-size: 1.2rem;
  }

  .front-image {
    width: 80%;
    max-width: 250px;
  }

  .image-container {
    min-width: 100%;
  }
}

@media (max-width: 612px) {
  .front-text h1 {
    font-size: 1.8rem;
  }

  .front-text h2 {
    font-size: 1rem;
  }

  .action-button {
    padding: 0.6rem 1.5rem;
    font-size: 1rem;
  }

  .card-grid {
    display: block;
    align-items: center;
    justify-content: center;
    min-height: 600px;
  }
}
</style>